document.addEventListener("DOMContentLoaded", () => {
  const categories = document.querySelectorAll(".tile-category");
  const tiles = document.querySelectorAll(".tile-item");

  function showTiles(categoryId) {
    tiles.forEach((tile) => {
      const tileCategories = tile.dataset.categories
        .split(",")
        .map((c) => c.trim().toLowerCase());
      tile.style.display = tileCategories.includes(categoryId.toLowerCase())
        ? "block"
        : "none";
    });
  }

  categories.forEach((cat) => {
    // Click event
    cat.addEventListener("click", () => {
      categories.forEach((c) => {
        c.classList.remove("active");
        c.setAttribute("aria-pressed", "false");
      });
      cat.classList.add("active");
      cat.setAttribute("aria-pressed", "true");
      showTiles(cat.dataset.category);
    });

    // Keyboard support
    cat.addEventListener("keydown", (event) => {
      if (
        event.key === "Enter" ||
        event.key === " " ||
        event.key === "Spacebar"
      ) {
        event.preventDefault();
        cat.click();
      }
    });
  });

  // Initialisierung
  if (categories.length > 0) {
    categories[0].classList.add("active");
    categories[0].setAttribute("aria-pressed", "true");
    showTiles(categories[0].dataset.category);
  }

  // Accordion Header
  const headers = document.querySelectorAll(".tile-header");
  headers.forEach((header) => {
    header.addEventListener("click", () => {
      const item = header.closest(".tile-item");
      const isActive = item.classList.contains("active");

      tiles.forEach((t) => t.classList.remove("active"));

      if (!isActive) {
        item.classList.add("active");
      }
    });
  });
});
